<template>
   <div class="about-first-section" v-if="about != null">
       <div class="container">
           <div class="column-container">
               <div class="col-left">
                    <div class="section-title">
                        <h5>{{about.upper_title}}</h5>
                        <h2>{{about.title}}</h2>
                    </div>
                    <div class="desc">
                        <p>{{about.desc}}</p>
                    </div>
               </div>
               <div class="col-right">
                   <div class="about-first-section-img">
                       <img :src="about.img" alt="">
                   </div>
               </div>
           </div>
          
       </div>
   </div>
</template>

<script>
    export default {
        name: 'about-elem-first',
        components: {
        },
        data () {
            return {
            }
        },
        methods: { 
            
        },
        computed: {
            about() {
                return this.$store.state.about.about_first_elem
            }
        },
        created () {
        },
        mounted () {
        },
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/about/about-elems/about-elem-first.scss';
    @import '@/styles/components/about/about-media/1-media.scss';
</style>